var PI2 = Math.PI * 2;
export function normalizeRadian(angle) {
    angle %= PI2;
    if (angle < 0) {
        angle += PI2;
    }
    return angle;
}



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/contain/util.js
// module id = 216
// module chunks = 1